import Button from "@mui/material/Button";

import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import AlertIcon from "@mui/icons-material/ErrorOutline";
import NitroModal from "../../Modal";
import ZIndex from "../../../styles/zindex";

import "./DeleteRailStationConfirmation.css";

const DeleteRailStationConfirmation = ({
  confirm,
  cancel,
}: {
  confirm: () => void;
  cancel: () => void;
}) => {
  return (
    <NitroModal
      open
      className="deleteRailStationConfirmation"
      style={{
        zIndex: ZIndex.DeleteRailStationConfirmation,
      }}
    >
      <div
        style={{
          width: 360,
          height: 410,
          backgroundColor: "white",
          borderRadius: 9,
          borderColor: "#09B0F2",
          borderStyle: "solid",
          borderWidth: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            height: 60,
            minHeight: 60,
            borderTopLeftRadius: 6,
            borderTopRightRadius: 6,
            backgroundColor: "#09B0F2",
            color: "white",
            display: "flex",
            alignItems: "center",
            paddingLeft: 20,
            fontSize: 20,
            fontWeight: 700,
          }}
        >
          Confirm delete changes
        </div>

        {/* BODY */}
        <div
          style={{
            height: "100%",
            padding: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexGrow: 1,
            gap: 15,
          }}
        >
          <AlertIcon style={{ color: "#C52F00", fontSize: 70 }} />

          <div
            style={{
              color: "black",
              textAlign: "center",
              fontSize: 20,
              fontWeight: 700,
            }}
          >
            Are you sure you want to delete this station
          </div>

          <div
            style={{
              color: "#878787",
              textAlign: "center",
              fontSize: 16,
              fontWeight: 400,
            }}
          >
            Any information you have entered will be lost permanently. This
            action cannot be undone.
          </div>
        </div>

        {/* FOOTER */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 10,
            paddingBottom: 30,
          }}
        >
          <Button
            id="deleteRailStationBackButton"
            data-testid="delete-rail-station-back-button"
            variant="outlined"
            onClick={cancel}
          >
            <CloseIcon />
            GO BACK
          </Button>
          <Button
            id="deleteRailStationConfirmButton"
            data-testid="delete-rail-station-confirm-button"
            variant="contained"
            color="primary"
            onClick={confirm}
          >
            <CheckIcon />
            YES, DISCARD
          </Button>
        </div>
      </div>
    </NitroModal>
  );
};

export default DeleteRailStationConfirmation;
